import { Model } from 'vue-mc';
import axios from 'axios';

export class BaseModel extends Model {
  createRequest(config) {
    return {
      send: () =>
        axios(config).then((response) => {
          return {
            getData: () => response.data,
            getStatus: () => response.status,
          };
        }),
    };
  }
}
